import { render, staticRenderFns } from "./AutoInvoice.vue?vue&type=template&id=630dead3&"
import script from "./AutoInvoice.vue?vue&type=script&lang=js&"
export * from "./AutoInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports